import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=3b59f4f7&scoped=true&"
import script from "./CurrencySelector.vue?vue&type=script&lang=js&"
export * from "./CurrencySelector.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CurrencySelector.vue?vue&type=style&index=1&id=3b59f4f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b59f4f7",
  null
  
)

export default component.exports